module.exports = __webpack_public_path__ + "img/content-1.36675e34.png";